// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MailChimp Lists Styles
 * Modern, responsive table view for MailChimp lists management
 */

.mailchimp-lists {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.lists-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Statistics */
.lists-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card.active .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.default .stat-icon {
  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);
}

.stat-card.synced .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.members .stat-icon {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-card.unsubscribed .stat-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.stat-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-content h3 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Bulk Actions */
.bulk-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.bulk-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.selected-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.bulk-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Lists Content */
.lists-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

/* Table Header */
.table-header {
  padding: 24px 24px 0 24px;
  text-align: center;
}

.table-header h3 {
  color: #2d3748;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.table-header p {
  color: #4a5568;
  font-size: 0.9rem;
  margin: 0 0 20px 0;
}

/* Scrollable Table Wrapper */
.scrollable-table-wrapper {
  overflow: auto;
  max-height: 70vh;
}

/* Lists Table */
.lists-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.lists-table th {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  font-weight: 600;
  padding: 16px 12px;
  text-align: left;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.lists-table th.select-column {
  width: 50px;
  text-align: center;
}

.lists-table th.list-name-column {
  width: 200px;
  min-width: 200px;
}

.lists-table th.list-id-column {
  width: 120px;
  min-width: 120px;
}

.lists-table th.status-column {
  width: 100px;
  min-width: 100px;
}

.lists-table th.members-column {
  width: 120px;
  min-width: 120px;
}

.lists-table th.sync-status-column {
  width: 120px;
  min-width: 120px;
}

.lists-table th.default-column {
  width: 120px;
  min-width: 120px;
}

.lists-table th.created-column {
  width: 120px;
  min-width: 120px;
}

.lists-table th.actions-column {
  width: 200px;
  min-width: 200px;
}

.lists-table td {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
}

.lists-table tr:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Select Column */
.select-cell {
  text-align: center;
}

.select-all-checkbox,
.list-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #0D3B66;
}

/* List Name Cell */
.list-name-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.list-name {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.list-description {
  color: #4a5568;
  font-size: 0.8rem;
  line-height: 1.3;
}

/* List ID Cell */
.list-id {
  color: #0D3B66;
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  font-weight: 500;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.status-badge.inactive {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

/* Members Info */
.members-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.member-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.unsubscribe-count {
  color: #e53e3e;
  font-size: 0.75rem;
}

/* Sync Status Badge */
.sync-status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sync-status-badge.synced {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.sync-status-badge.pending {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.sync-status-badge.failed {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

.sync-status-badge.unknown {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

/* Default Badge */
.default-badge {
  color: #3182ce;
  font-weight: 600;
  font-size: 0.8rem;
}

/* Created Date */
.created-date {
  color: #4a5568;
  font-size: 0.8rem;
}

/* List Actions */
.list-actions {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.6;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.empty-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.empty-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Modal Styles */
/* Modal Overlay - Now using global styles from design-system.css */

.modal-content {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.2),
    0 10px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content.large {
  max-width: 800px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-header h3 {
  color: #2d3748;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #4a5568;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-button:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #2d3748;
}

.modal-body {
  padding: 24px;
}

/* Form Styles */
/* Form Groups - Now using global styles from design-system.css */

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #0D3B66;
}

/* List Details */
.list-details {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-section h4 {
  color: #2d3748;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 500;
  min-width: 120px;
}

.detail-value {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 400;
  text-align: right;
  word-break: break-all;
}

.detail-value.status-active {
  color: #38a169;
  font-weight: 600;
}

.detail-value.status-inactive {
  color: #718096;
  font-weight: 600;
}

.detail-value.sync-synced {
  color: #38a169;
  font-weight: 600;
}

.detail-value.sync-pending {
  color: #d69e2e;
  font-weight: 600;
}

.detail-value.sync-failed {
  color: #e53e3e;
  font-weight: 600;
}

.detail-value.sync-unknown {
  color: #718096;
  font-weight: 600;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-danger {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.4);
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.8rem;
}

/* Scrollbar Styling */
.scrollable-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scrollable-table-wrapper::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.scrollable-table-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  border-radius: 4px;
}

.scrollable-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .lists-stats {
    grid-template-columns: repeat(3, 1fr);
  }

  .lists-table {
    min-width: 1000px;
  }
}

@media (max-width: 768px) {
  .mailchimp-lists {
    padding: 16px;
  }

  .lists-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .lists-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .bulk-actions {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .bulk-buttons {
    justify-content: center;
    flex-wrap: wrap;
  }

  .lists-table {
    min-width: 800px;
  }

  .list-actions {
    flex-direction: column;
    gap: 4px;
  }

  .empty-actions {
    flex-direction: column;
    align-items: center;
  }

  .modal-content {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .mailchimp-lists {
    padding: 12px;
  }

  .lists-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .lists-stats {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 16px;
  }

  .lists-table th,
  .lists-table td {
    padding: 8px 6px;
    font-size: 0.8rem;
  }

  .lists-table {
    min-width: 700px;
  }

  .modal-content {
    margin: 5px;
    max-width: calc(100vw - 10px);
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-actions {
    padding: 16px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mailchimp/MailChimpLists.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB,mEAAmE;;AAEnE;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB,iEAAiE;;AAEjE;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/**\n * MailChimp Lists Styles\n * Modern, responsive table view for MailChimp lists management\n */\n\n.mailchimp-lists {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.lists-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Statistics */\n.lists-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card.active .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.default .stat-icon {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);\n}\n\n.stat-card.synced .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.members .stat-icon {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-card.unsubscribed .stat-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-content h3 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Bulk Actions */\n.bulk-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(102, 126, 234, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.bulk-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.selected-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.bulk-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Lists Content */\n.lists-content {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n}\n\n/* Table Header */\n.table-header {\n  padding: 24px 24px 0 24px;\n  text-align: center;\n}\n\n.table-header h3 {\n  color: #2d3748;\n  font-size: 1.4rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.table-header p {\n  color: #4a5568;\n  font-size: 0.9rem;\n  margin: 0 0 20px 0;\n}\n\n/* Scrollable Table Wrapper */\n.scrollable-table-wrapper {\n  overflow: auto;\n  max-height: 70vh;\n}\n\n/* Lists Table */\n.lists-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.lists-table th {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  font-weight: 600;\n  padding: 16px 12px;\n  text-align: left;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.lists-table th.select-column {\n  width: 50px;\n  text-align: center;\n}\n\n.lists-table th.list-name-column {\n  width: 200px;\n  min-width: 200px;\n}\n\n.lists-table th.list-id-column {\n  width: 120px;\n  min-width: 120px;\n}\n\n.lists-table th.status-column {\n  width: 100px;\n  min-width: 100px;\n}\n\n.lists-table th.members-column {\n  width: 120px;\n  min-width: 120px;\n}\n\n.lists-table th.sync-status-column {\n  width: 120px;\n  min-width: 120px;\n}\n\n.lists-table th.default-column {\n  width: 120px;\n  min-width: 120px;\n}\n\n.lists-table th.created-column {\n  width: 120px;\n  min-width: 120px;\n}\n\n.lists-table th.actions-column {\n  width: 200px;\n  min-width: 200px;\n}\n\n.lists-table td {\n  padding: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  vertical-align: middle;\n}\n\n.lists-table tr:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n/* Select Column */\n.select-cell {\n  text-align: center;\n}\n\n.select-all-checkbox,\n.list-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #0D3B66;\n}\n\n/* List Name Cell */\n.list-name-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.list-name {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.list-description {\n  color: #4a5568;\n  font-size: 0.8rem;\n  line-height: 1.3;\n}\n\n/* List ID Cell */\n.list-id {\n  color: #0D3B66;\n  font-family: 'Courier New', monospace;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.active {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.status-badge.inactive {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n/* Members Info */\n.members-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.member-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.unsubscribe-count {\n  color: #e53e3e;\n  font-size: 0.75rem;\n}\n\n/* Sync Status Badge */\n.sync-status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sync-status-badge.synced {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.sync-status-badge.pending {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.sync-status-badge.failed {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n.sync-status-badge.unknown {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n/* Default Badge */\n.default-badge {\n  color: #3182ce;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n/* Created Date */\n.created-date {\n  color: #4a5568;\n  font-size: 0.8rem;\n}\n\n/* List Actions */\n.list-actions {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.empty-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Modal Styles */\n/* Modal Overlay - Now using global styles from design-system.css */\n\n.modal-content {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 20px 40px rgba(0, 0, 0, 0.2),\n    0 10px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content.large {\n  max-width: 800px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.modal-header h3 {\n  color: #2d3748;\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.8rem;\n  color: #4a5568;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.close-button:hover {\n  background: rgba(0, 0, 0, 0.1);\n  color: #2d3748;\n}\n\n.modal-body {\n  padding: 24px;\n}\n\n/* Form Styles */\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0D3B66;\n}\n\n/* List Details */\n.list-details {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.detail-section h4 {\n  color: #2d3748;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.detail-item:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 500;\n  min-width: 120px;\n}\n\n.detail-value {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 400;\n  text-align: right;\n  word-break: break-all;\n}\n\n.detail-value.status-active {\n  color: #38a169;\n  font-weight: 600;\n}\n\n.detail-value.status-inactive {\n  color: #718096;\n  font-weight: 600;\n}\n\n.detail-value.sync-synced {\n  color: #38a169;\n  font-weight: 600;\n}\n\n.detail-value.sync-pending {\n  color: #d69e2e;\n  font-weight: 600;\n}\n\n.detail-value.sync-failed {\n  color: #e53e3e;\n  font-weight: 600;\n}\n\n.detail-value.sync-unknown {\n  color: #718096;\n  font-weight: 600;\n}\n\n/* Modal Actions */\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px 24px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.4);\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.8rem;\n}\n\n/* Scrollbar Styling */\n.scrollable-table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scrollable-table-wrapper::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n}\n\n.scrollable-table-wrapper::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  border-radius: 4px;\n}\n\n.scrollable-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .lists-stats {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .lists-table {\n    min-width: 1000px;\n  }\n}\n\n@media (max-width: 768px) {\n  .mailchimp-lists {\n    padding: 16px;\n  }\n\n  .lists-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .lists-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n\n  .bulk-actions {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .bulk-buttons {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .lists-table {\n    min-width: 800px;\n  }\n\n  .list-actions {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .empty-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .modal-content {\n    margin: 10px;\n    max-width: calc(100vw - 20px);\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n@media (max-width: 480px) {\n  .mailchimp-lists {\n    padding: 12px;\n  }\n\n  .lists-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .lists-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    padding: 16px;\n  }\n\n  .lists-table th,\n  .lists-table td {\n    padding: 8px 6px;\n    font-size: 0.8rem;\n  }\n\n  .lists-table {\n    min-width: 700px;\n  }\n\n  .modal-content {\n    margin: 5px;\n    max-width: calc(100vw - 10px);\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-actions {\n    padding: 16px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
